<script lang="ts">
  import { TwistStack, TwistDivider, ResponsiveVars } from '@twist/core';
  import { cx } from '@emotion/css';

  import ReduceColor from '../CheckboxControls/ReduceColor.svelte';
  import ReduceMotion from '../CheckboxControls/ReduceMotion.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(14, 18))
    .toCSS();
</script>

<div class={cx(responsiveVars, 'accessibility-controls')} data-testid="accessibility-modal">
  <TwistStack direction="row" justify="space-between" align="center">
    <span class="accessibility-control-text">Reduce color</span>
    <ReduceColor />
  </TwistStack>
  <TwistDivider color="gray-70" margin={4} />

  <TwistStack direction="row" justify="space-between" align="center">
    <span class="accessibility-control-text">Reduce motion</span>
    <ReduceMotion />
  </TwistStack>
</div>

<style lang="scss">
  @import 'src/scss/media';

  span {
    font-family: var(--font-family-primary);
    color: var(--twist-color-gray-0);
    font-size: var(--font-size);
    font-weight: 500;
    line-height: 130%;

    @include at('lg') {
      line-height: 120%;
    }
  }
</style>
